/* import __COLOCATED_TEMPLATE__ from './qualify-leads.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();